import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { useAuth } from 'context/AuthContext';
import DownloadIcon from '@mui/icons-material/Download';
import { snackbarService } from 'services/snackbarService';

interface Props {
  path: string;
}

export default function ExportedItemOptions({ path }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDownloadClick = () => {
    const link = document.createElement('a');
    link.href = path;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      snackbarService.showSnackbar('File has been downloaded successfully', 'success');
    }, 500);
    handleClose();
  };


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>

      <IconButton
        onClick={handleClick}
        className={globalStyles.p0}
        disableRipple
      >
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          <IconButton
            onClick={onDownloadClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <DownloadIcon sx={{ color: colors.black, fontSize: 21 }} />
            </Box>
            <CustomText text="Download" ml="5px" color={colors.black} />
          </IconButton>

        </Box>
      </Popover>

    </div>
  );
}
